import { render, staticRenderFns } from "./RichTextEditor2.vue?vue&type=template&id=54ab0904&"
import script from "./RichTextEditor2.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor2.vue?vue&type=script&lang=js&"
import style0 from "./RichTextEditor2.vue?vue&type=style&index=0&id=54ab0904&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports